// Featured championships (covers only — no specific match schedules)

export const championships = [
  {
    id: "brasileirao",
    name: "Brasileirão Série A",
    tagline: "Todos os jogos do Campeonato Brasileiro",
    badge: "BR",
    gradient: "from-emerald-600 via-emerald-800 to-black",
    accent: "bg-emerald-500",
    channels: "Premiere · Globo · SporTV · Cazé TV",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/li764kfo_Brasil.webp",
  },
  {
    id: "libertadores",
    name: "Copa Libertadores",
    tagline: "A glória eterna da América do Sul",
    badge: "CL",
    gradient: "from-yellow-500 via-orange-700 to-black",
    accent: "bg-yellow-500",
    channels: "ESPN · Paramount+ · SBT",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/ipecfigi_copa-libertadores.webp",
  },
  {
    id: "champions",
    name: "UEFA Champions League",
    tagline: "As melhores noites do futebol europeu",
    badge: "UCL",
    gradient: "from-blue-700 via-indigo-900 to-black",
    accent: "bg-indigo-500",
    channels: "TNT Sports · HBO Max · SBT",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/0ugttww3_chapeons.jpg",
  },
  {
    id: "copadobrasil",
    name: "Copa do Brasil",
    tagline: "O torneio que corta o país inteiro",
    badge: "CDB",
    gradient: "from-neutral-600 via-neutral-800 to-black",
    accent: "bg-brand",
    channels: "Globo · SporTV · Prime Video",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/3gwgs8be_55234464843_a8190255d0_k-36721432.webp",
  },
  {
    id: "premier",
    name: "Premier League",
    tagline: "O campeonato mais disputado da Inglaterra",
    badge: "PL",
    gradient: "from-purple-700 via-fuchsia-900 to-black",
    accent: "bg-fuchsia-500",
    channels: "ESPN · Disney+ · Xsports",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/0jopekoi_images.jpg",
  },
  {
    id: "laliga",
    name: "LaLiga",
    tagline: "A magia dos clássicos espanhóis",
    badge: "LL",
    gradient: "from-brand-dark via-indigo-950 to-black",
    accent: "bg-brand-light",
    channels: "ESPN · Disney+",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/keddvii2_la%20liga.png",
  },
  {
    id: "sulamericana",
    name: "Sul-Americana",
    tagline: "A segunda maior taça continental",
    badge: "SA",
    gradient: "from-sky-700 via-blue-900 to-black",
    accent: "bg-sky-500",
    channels: "ESPN · Paramount+",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/2bf9j5qa_Sulamericana.webp",
  },
  {
    id: "serieb",
    name: "Brasileirão Série B",
    tagline: "Emoção e disputa por acesso à elite",
    badge: "B",
    gradient: "from-lime-600 via-emerald-800 to-black",
    accent: "bg-lime-500",
    channels: "SporTV · Premiere · ESPN",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_hardcore-lichterman-3/artifacts/biikm8jw_Brasileirao%20b.webp",
  },
];
